import axios from 'axios';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import Swal from 'sweetalert2';
import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { baseurl } from '../utility/helper';

const Reports = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    chapterId: '',
    membershipStatus: '',
    selectedFields: [],
    startDate: null,
    endDate: null,
    joinDateStart: null,
    joinDateEnd: null,
    renewDateStart: null,
    renewDateEnd: null,
  });

  const [filteredData, setFilteredData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [noData, setNoData] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [chapters, setChapters] = useState([]);
  const [membershipStatuses, setMembershipStatuses] = useState([]);

  const tableRef = useRef(null);
  const exclusiveFilters = [
    'join_date',
    'renew_date',
    'active',
    'coming_march',
    'last_march',
    'expire',
    'new_member'
  ];

  const fieldOptions = [
    { value: 'chapter', label: 'Chapter' },
    { value: 'status', label: 'Membership Status' },
    { value: 'join_date', label: 'Join Date' },
    { value: 'renew_date', label: 'Renewed' },
    { value: 'active', label: 'Active Member' },
    { value: 'coming_march', label: 'Upcoming March Expired' },
    { value: 'last_march', label: 'Last March Expired' },
    { value: 'expire', label: 'Expired Members' },
    { value: 'new_member', label: 'New Member' }
  ];

  useEffect(() => {
    const fetchChaptersAndStatuses = async () => {
      try {
        const chapterRes = await axios.get(`${baseurl}/admin/chapters`);
        setChapters(chapterRes.data);

        const statusRes = await axios.get(`${baseurl}/admin/members/memberterms`);
        setMembershipStatuses(statusRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchChaptersAndStatuses();
  }, []);

  const formatDate = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchData = async (filters) => {
    try {
      const queryParams = new URLSearchParams();

      if (roleid === 2 && !initialChapter) {
        Swal.fire({
          icon: 'warning',
          title: 'Chapter Missing',
          text: 'Please select a chapter before fetching data.',
        });
        return [];
      }

      // Chapter & Status
      if (filters.chapterId) queryParams.append('chapter_id', filters.chapterId);
      if (filters.membershipStatus) queryParams.append('membershipStatus', filters.membershipStatus);

      // Join Date Range
      if (filters.joinDateStart) queryParams.append('joinDateStart', formatDate(filters.joinDateStart));
      if (filters.joinDateEnd) queryParams.append('joinDateEnd', formatDate(filters.joinDateEnd));

      // Renew Date Range
      if (filters.renewDateStart) queryParams.append('renewDateStart', formatDate(filters.renewDateStart));
      if (filters.renewDateEnd) queryParams.append('renewDateEnd', formatDate(filters.renewDateEnd));

      // New Member Date Range
      if (filters.newMemberStart) queryParams.append('newMemberStart', formatDate(filters.newMemberStart));
      if (filters.newMemberEnd) queryParams.append('newMemberEnd', formatDate(filters.newMemberEnd));

      if (filters.expireStart) queryParams.append('expireStart', formatDate(filters.expireStart));
      if (filters.expireEnd) queryParams.append('expireEnd', formatDate(filters.expireEnd));

      // Status Flags
      if (filters.memberactive) queryParams.append('member_active', filters.memberactive);
      if (filters.memberexpire) queryParams.append('member_expire', filters.memberexpire);
      if (filters.comingmarch) queryParams.append('coming_march', filters.comingmarch);
      if (filters.lastmarch) queryParams.append('last_march', filters.lastmarch);
      if (filters.newmember) queryParams.append('new_member', filters.newmember);



      // API call
      const response = await axios.get(`${baseurl}/admin/filtered?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  };

  function formatDateshow(data) {
    if (!data) return '';
    let d = new Date(data);
    let day = String(d.getDate()).padStart(2, '0');
    let month = String(d.getMonth() + 1).padStart(2, '0');
    let year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }


  useEffect(() => {
    if (hasSearched && showTable) {
      const dataTable = $(tableRef.current).DataTable({
        destroy: true,
        dom: 'Blfrtip',
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
        buttons: [
          { extend: 'colvis', className: 'btn btn-secondary dttable', columns: ':visible' },
          { extend: 'copyHtml5', className: 'btn btn-secondary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'excelHtml5', className: 'btn btn-secondary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'csvHtml5', className: 'btn btn-secondary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'pdfHtml5', className: 'btn btn-secondary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'print', className: 'btn btn-secondary dttable', exportOptions: { columns: ':visible' } }
        ],
        data: filteredData,
        columns: [
          { data: null, title: 'Sr.No', className: "text-center",
            render: (data, type, row, meta) => meta.row + 1,
          },
          { title: 'Membership No', data: 'membership_no',
            render: (data, type, row) =>
              type !== 'display'
                ? (data ?? '')
                : `<a href="/admin/EditMember?memberId=${row.member_id}&edit=false" onclick="event.preventDefault(); window.open(this.href, '_blank');">${data ?? ''}</a>`,
          },
          { title: 'Chapter ID', data: 'chapter_id' },
          { title: 'Name', data: null,
            render: row => `${row.first_name || ''} ${row.last_name || ''}`
          },
          { title: 'Mobile Phone', data: 'mobile_no' },
          { title: 'Email', data: 'email' },
          { title: 'Address', data: 'present_address' },
          { title: 'City', data: 'present_city' },
          { title: 'State', data: 'present_state' },
          { title: 'Pincode', data: 'present_pincode' },
          { title: 'Gender', data: 'gender' },
          {
            title: 'DOB',
            data: 'dob',
           render: function (data, type) {
              if (type === 'display') {
                return formatDateshow(data);
              }
              return data; // for sorting
            }
          },
          
          { 
            title: 'Join Date', 
            data: 'date_joining',
            render: function (data, type) {
                if (type === 'display') {
                  return formatDateshow(data);
                }
                return data; // for sorting
              }
          },
          { title: 'Notes', data: 'note' },
          { 
            title: 'Valid Upto', 
            data: 'membership_exp_date',
            render: function (data, type) {
              if (type === 'display') {
                return formatDateshow(data);
              }
              return data; // for sorting
            }
          },
          { 
            title: 'Last Renewal', 
            data: 'last_renewal_date',
            render: function (data, type) {
              if (type === 'display') {
                return formatDateshow(data);
              }
              return data; // for sorting
            }
          },
          { 
            title: 'Membership Term', 
            data: 'status_name'
          },
          {
            title: `<input type="checkbox" id="select-all-renew" /> Send Mail`,
            data: null,
            orderable: false,
            render: function (data, type, row) {
              const today = new Date();

              // check expiry
              const isExpired = row.membership_exp_date && new Date(row.membership_exp_date) < today;

              // check chapter match or admin role
              const canSee =
                roleid === 1 || String(initialChapter) === String(row.chapter_id);

              if (isExpired && canSee) {
                return `<input type="checkbox" class="renew-checkbox" data-id="${row.member_id}" />`;
              }
              return '';
            }
          }

        ],
        initComplete: function () {
          $('.dt-length select').addClass('form-select form-select-sm');
        }
      });

      // z-index fix
      $('.dt-buttons .dttable').css('z-index', 0);

      // Select/Deselect All
      $(tableRef.current).on('change', '#select-all-renew', function () {
        const isChecked = $(this).is(':checked');
        $('.renew-checkbox').prop('checked', isChecked);
      });

    }

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };

  }, [hasSearched, showTable, filteredData]);

  const handleFieldSelection = (selectedOptions) => {
    const selectedValues = selectedOptions.map(option => option.value);

    const updatedFilters = {
      ...filters,
      selectedFields: selectedValues,
      chapterId: selectedValues.includes('chapter') ? filters.chapterId : '',
      membershipStatus: selectedValues.includes('status') ? filters.membershipStatus : '',
      memberactive: selectedValues.includes('active') ? 1 : '',
      memberexpire: selectedValues.includes('expire') ? 1 : '',
      comingmarch: selectedValues.includes('coming_march') ? 1 : '',
      lastmarch: selectedValues.includes('last_march') ? 1 : '',
      newmember: selectedValues.includes('new_member') ? 1 : '',
      startDate: null,
      endDate: null,
      joinDateStart: null,
      joinDateEnd: null,
      renewDateStart: null,
      renewDateEnd: null,
      newMemberStart: null,
      newMemberEnd: null,
      expireStart:null,
      expireEnd:null,
    };

    setFilters(updatedFilters);
  };



  const handleDateChange = (date, type) => {
    let updatedFilters = { ...filters, [type]: date };

    if (filters.selectedFields.includes('join_date') && filters.selectedFields.includes('renew_date')) {
      updatedFilters.joinDateStart = type === "startDate" ? date : updatedFilters.joinDateStart;
      updatedFilters.joinDateEnd = type === "endDate" ? date : updatedFilters.joinDateEnd;
      updatedFilters.renewDateStart = type === "startDate" ? date : updatedFilters.renewDateStart;
      updatedFilters.renewDateEnd = type === "endDate" ? date : updatedFilters.renewDateEnd;
    } else if (filters.selectedFields.includes('join_date')) {
      updatedFilters.joinDateStart = type === "startDate" ? date : updatedFilters.joinDateStart;
      updatedFilters.joinDateEnd = type === "endDate" ? date : updatedFilters.joinDateEnd;
    } else if (filters.selectedFields.includes('renew_date')) {
      updatedFilters.renewDateStart = type === "startDate" ? date : updatedFilters.renewDateStart;
      updatedFilters.renewDateEnd = type === "endDate" ? date : updatedFilters.renewDateEnd;
    } else if (filters.selectedFields.includes('new_member')) {
      updatedFilters.newMemberStart = type === "startDate" ? date : updatedFilters.newMemberStart;
      updatedFilters.newMemberEnd = type === "endDate" ? date : updatedFilters.newMemberEnd;
    } else if (filters.selectedFields.includes('expire')) {
      updatedFilters.expireStart = type === "startDate" ? date : updatedFilters.expireStart;
      updatedFilters.expireEnd = type === "endDate" ? date : updatedFilters.expireEnd;
    }


    setFilters(updatedFilters);
  };


  const handleBulkSendMail = async () => {
    const selectedIds = [];
    $('.renew-checkbox:checked').each(function () {
      selectedIds.push($(this).data('id'));
    });

    if (selectedIds.length === 0) {
      Swal.fire('No Selection', 'Please select at least one member.', 'warning');
      return;
    }

    const confirm = await Swal.fire({
      title: 'Send Renewal Mails?',
      text: `Do you want to send renewal mails to ${selectedIds.length} members?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Send',
      cancelButtonText: 'No'
    });

    if (confirm.isConfirmed) {
    try {
        // Show loading while sending mails
        Swal.fire({
        title: 'Sending...',
        text: 'Please wait while renewal mails are being sent.',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
        });

        // Send POST request to backend
        const response = await axios.post(`${baseurl}/admin/members/send_renew_mail`, { memberIds: selectedIds });

        // If success
        Swal.fire('Success', response.data.message || 'Renewal mails sent successfully!', 'success');
    } catch (error) {
        console.error('Error sending bulk renewal mails:', error);

        Swal.fire(
        'Error',
        error.response?.data?.message || 'Failed to send renewal mails.',
        'error'
        );
    }
    }

  };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };

    const handleSearch = async () => {
        setLoading(true);

        // Show loading modal while fetching data
        Swal.fire({
            title: 'Searching...',
            text: 'Please wait while we fetch the report data.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const data = await fetchData(filters);
            setFilteredData(data);
            setNoData(data.length === 0);
            setShowTable(data.length > 0);
            setHasSearched(true);
        } finally {
            setLoading(false);
            Swal.close();
        }
    };

    return (
        <div className="container mt-4">
            <div className="card p-4 shadow-sm">
                <h2 className="text-center mb-4">Report</h2>

                {/* Filters Section */}
                <div className="row g-3">
                    <div className="col-md-12">
                        <label className="form-label">Select Fields:</label>
                        <Select
                          isMulti
                          options={fieldOptions}
                          value={fieldOptions.filter(opt => filters.selectedFields.includes(opt.value))}
                          onChange={handleFieldSelection}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isOptionDisabled={(option) => {
                            // If an exclusive filter is already chosen, disable all other exclusive filters
                            const alreadySelected = filters.selectedFields.find(v => exclusiveFilters.includes(v));
                            return alreadySelected && exclusiveFilters.includes(option.value) && !filters.selectedFields.includes(option.value);
                          }}
                        />
                    </div>

                    {filters.selectedFields.includes('chapter') && (
                        <div className="col-md-4">
                            <label className="form-label">Chapter ID:</label>
                            <select
                                className="form-select"
                                name="chapterId"
                                value={filters.chapterId}
                                onChange={handleFilterChange}
                                >
                                <option value="" disabled>-- Select Chapter --</option>
                                {chapters.filter(term => term.chapter_id !== 1) // Exclude chapter_id = 1
                                    .map((term) => (
                                        <option key={term.chapter_id} value={term.chapter_id}>
                                        {term.chapter_name}
                                        </option>
                                    ))}
                                </select>

                        </div>
                    )}

                    {filters.selectedFields.includes('status') && (
                        <div className="col-md-4">
                            <label className="form-label">Membership Status:</label>
                            <select
                                className="form-select"
                                name="membershipStatus"
                                value={filters.membershipStatus}
                                onChange={handleFilterChange}
                                >
                                <option value="">-- Select Status --</option>
                                {membershipStatuses.map((status) => (
                                    <option key={status.member_status_id} value={status.member_status_id}>
                                    {status.status_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {(filters.selectedFields.includes('join_date') || filters.selectedFields.includes('renew_date') ||  filters.selectedFields.includes('new_member') ||
                      filters.selectedFields.includes('expire')) && (
                    <>
                        <div className="col-md-4">
                            <label className="form-label">Start Date:</label>
                            <DatePicker
                                selected={filters.startDate}
                                onChange={(date) => handleDateChange(date, "startDate")}
                                dateFormat="dd-MM-yyyy"
                                className="form-control"
                                placeholderText="Select start date"
                            />
                        </div>

                        <div className="col-md-4">
                            <label className="form-label">End Date:</label>
                            <DatePicker
                                selected={filters.endDate}
                                onChange={(date) => handleDateChange(date, "endDate")}
                                dateFormat="dd-MM-yyyy"
                                className="form-control"
                                placeholderText="Select end date"
                            />
                        </div>
                    </>
                    )}


                    <div className="col-12 text-center">
                        <button className="mt-3" style={{ borderRadius: '8px' }} onClick={handleSearch} disabled={loading}>
                          {loading ? 'Loading...' : 'Search'}
                        </button>
                    </div>
                </div>
                {/* Table Section */}
                <hr />
                {!hasSearched ? (
                    <h3 className="text-center text-muted">Please perform a search to view data.</h3>
                ) : noData ? (
                    <h3 className="text-center text-danger">No Data Available</h3>
                ) : (
                    <div>
                        <button className="btn btn-primary mb-3" onClick={handleBulkSendMail} style={{zIndex:'0'}}>
                            Send Renewal Mails
                        </button>
                        <div className="table-responsive">
                            <table id="reports" className="table table-striped table-bordered" ref={tableRef}></table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Reports;